import { render } from "./PatientDetalisOverlay.vue?vue&type=template&id=f6a776a4&scoped=true&lang=pug"
import script from "./PatientDetalisOverlay.vue?vue&type=script&lang=js"
export * from "./PatientDetalisOverlay.vue?vue&type=script&lang=js"

import "./PatientDetalisOverlay.vue?vue&type=style&index=0&id=f6a776a4&scoped=true&lang=scss"
import "./PatientDetalisOverlay.vue?vue&type=style&index=1&id=f6a776a4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a776a4"]])

export default __exports__